import { useMutation } from '@apollo/client';
import { useTranslation } from 'react-i18next';
import { useNotifications, type ApiOptions } from '../helpers';
import { DeleteLayoutDocument } from './delete.generated';

export const useDeleteLayout = (options: ApiOptions<typeof DeleteLayoutDocument> = {}) => {
  const { t } = useTranslation();
  return useMutation(DeleteLayoutDocument, {
    ...useNotifications(DeleteLayoutDocument, {
      failure: t('api.common.error_generic'),
      success: t('api.layouts.delete_success'),
    }),

    update(cache, { data }) {
      if (data?.deleteLayout?.layout == null) return;
      cache.evict({ id: cache.identify(data.deleteLayout.layout) });
    },

    ...options,
  });
};
